import { FC } from 'react';
import styled from 'styled-components';

export interface IProps {
  children?: React.ReactNode;
  isCentered?: boolean;
  className?: string;
  isCategoryWrapper?: boolean;
}

const Tabs: FC<IProps> = ({ children, className, isCentered = false, isCategoryWrapper = false }: IProps) => {
  return (
    <TabsWrapper
      className={className}
      isCentered={isCentered}
      isCategoryWrapper={isCategoryWrapper}
    >
      {children}
    </TabsWrapper>
  );
};

export default Tabs;

const TabsWrapper = styled.div<{
  isCentered: boolean;
  isCategoryWrapper: boolean;
}>`
  margin-bottom: 1.25rem;
  border-bottom: ${props => (props.isCategoryWrapper ? '0' : `1px solid ${props.theme.colors.light}`)};
  background: ${props => (props.isCategoryWrapper ? props.theme.colors.lighter : 'none')};
  display: flex;
  flex-wrap: wrap;
  justify-content: ${props => (props.isCentered ? 'center' : 'flex-start')};

  @media ${props => props.theme.breakpoints.md} {
    flex-direction: row;
    align-items: center;
    text-align: left;
    border-bottom: none;
    margin-bottom: 2rem;
    gap: 1rem;
    flex-wrap: nowrap;
    overflow-x: auto;

    > * {
      white-space: nowrap;
    }

    & > .refresh-button span::after {
      display: none;
    }

    & > .refresh-button {
      display: none;
    }
  }
`;
